module.exports = __webpack_public_path__ + "assets/img/sukikamo_menu.8044b627.svg";